import { Divider } from "antd";
import React from "react";
import trans from "../../../../../utils";

export default function SetupTimeline({ page, checked }) {
	const timeline = ["project", "building", "level", "space"];
	return (
		<div
			className="d-flex align-items-center justify-content-between"
			style={{
				padding: "8px",
				marginBottom: "16px",
			}}
		>
			{timeline.map((item, index) => (
				<React.Fragment key={index}>
					<div className="text-center">
						<div
							className={
								checked[index]
									? "project-setup-timline-done"
									: "project-setup-timline"
							}
							style={{ marginInline: "auto" }}
						></div>
						<div className="text-capitalize mt-2" style={{ fontWeight: "500" }}>
							{trans(item)}
						</div>
					</div>

					{index !== timeline.length - 1 && (
						<Divider
							className={
								checked[index] ? "timeline-divider-done" : "timeline-divider"
							}
						/>
					)}
				</React.Fragment>
			))}
		</div>
	);
}
